import { Skeleton } from "@mui/material";
import { Flex } from "~/components/Flex";

export const SecurityPipelineGithubPageTabHeadingSkeleton = () => {
  return (
    <Flex flexDirection="column" width="100%">
      <Skeleton
        variant="text"
        width="40%"
        height={28}
        animation="wave"
        sx={{ fontSize: "20px", mb: 1 }}
      />
      <Skeleton variant="text" width="60%" height={24} animation="wave" />
    </Flex>
  );
};
